import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Router, NavigationEnd } from "@angular/router";
import {
  Component,
  ViewChildren,
  AfterViewInit,
  AfterContentInit,
} from "@angular/core";
import { SelectComponent } from "ng2-select/ng2-select";
import Swal from "sweetalert2";

import { CursosService } from "./../_shared/curso/cursos.service";
import { Curso, Campus, Turno } from "./../_shared/curso/curso";
import { PessoaService } from "./../_shared/pessoa/pessoa.service";
import { SessionService } from "./../_shared/session/session.service";
import { ProcessoService } from "./../_shared/processo/processo.service";
import { ProcessoSeletivo } from "./../_shared/processo/processo-seletivo";
import { CandidatoService } from "./../_shared/candidato/candidato.service";
import { RedirecionamentoMatriculaService } from "./../_shared/redirecionamento-matricula/redirecionamento-matricula.service";
import { Candidato } from "./../_shared/candidato/candidato";
import { BarraProgressoService } from "./../_shared/barra-progresso/barra-progresso.service";
import { environment } from "../../environments/environment";
import { MatriculaService } from "./../_shared/matricula/matricula.service"; // Ch: 427368 - Jonathan Santos - 12/03/2025
@Component({
  selector: "app-curso",
  templateUrl: "./curso.component.html",
  styleUrls: ["./curso.component.css"],
})
export class CursoComponent implements AfterContentInit {
  public cursosSource = [];
  public cursos = [];
  public campi = [];
  public turnos = [];
  public instrumentos = [];

  public paramtipoProcesso;
  public paramCurso;
  public paramCampus;
  public paramTurno;
  public paramInstrumento;

  public grau;
  public ingresso;
  public curso = "";
  public campus = "";
  public turno = "";
  public instrumento = "";
  public matriculaOnlineRedirecionamento: boolean;

  public unidecode = require("unidecode");

  public formulario: FormGroup;
  public curso_placeholder = "Curso";
  public curso_classe: string;
  public campus_placeholder = "Campus";
  public campus_classe: string;
  public turno_placeholder = "Turno";
  public turno_classe: string;
  public instrumento_placeholder = "Instrumento";
  public instrumento_classe: string;
  public PrcOfeObs: string;

  public bolsa: boolean;

  public stringSimilarity = require("string-similarity");

  public processo;
  public ocorrencia;
  public processos = [];
  public nomeProcessoSelecionado: string;

  public aceiteEdital = false;
  public aceiteBolsa = false;

  constructor(
    private cursosService: CursosService,
    private router: Router,
    private pessoaService: PessoaService,
    private SessionService: SessionService,
    private ProcessoService: ProcessoService,
    private CandidatoService: CandidatoService,
    private BarraProgressoService: BarraProgressoService,
    private RedirecionamentoMatriculaService: RedirecionamentoMatriculaService,
    private MatriculaService: MatriculaService // Ch: 427368 - Jonathan Santos - 12/03/2025
  ) {}

  @ViewChildren(SelectComponent)
  selectElements;

  ngAfterContentInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    this.paramtipoProcesso = this.SessionService.getValor("processo");

    if (this.paramtipoProcesso == "null") {
      this.paramtipoProcesso = null;
    }

    this.paramCurso = this.SessionService.getValor("curso").replace(/-/g, " ");
    this.paramCampus = this.SessionService.getValor("campus")
      ? this.SessionService.getValor("campus")
      : "";
    this.paramTurno = this.SessionService.getValor("turno")
      ? this.SessionService.getValor("turno")
      : "";
    this.instrumento = this.SessionService.getValor("instrumento")
      ? this.SessionService.getValor("instrumento")
      : "";

    let cursos = JSON.parse(this.SessionService.getValor("cursosSeletivo"));
    this.loadCursosProcessoSeletivo(this.cursosService.setCursos(cursos));
  }

  loadCursosProcessoSeletivo(cursos) {
    this.processo = this.ProcessoService.getProcessoSeletivoSelecionado();
    this.ocorrencia = this.ProcessoService.getOcorrenciaSelecionada();
    this.processos = this.ProcessoService.getProcessos();
    this.nomeProcessoSelecionado = this.ProcessoService.getNomeProcesso();
    this.BarraProgressoService.atualizaNomeProcesso(
      this.nomeProcessoSelecionado
    );

    if (this.processos.length == 0) {
      this.router.navigateByUrl("/login");
    }

    this.searchArrayProcesso(cursos);

    // this.cursosSource = cursos;
    //
    // this.cursos = this.criaArrayChave(cursos);

    if (this.curso) {
      this.campi = this.criaArrayChave(this.cursosSource[this.curso]);
      if (
        this.campus &&
        this.cursosSource[this.curso] &&
        this.cursosSource[this.curso][this.campus]
      ) {
        this.turnos = this.criaArrayChave(
          this.cursosSource[this.curso][this.campus]
        );

        if (
          this.turno &&
          this.cursosSource[this.curso][this.campus][this.turno].PrcInstrumento
        ) {
          this.instrumentos = this.criaArrayInstrumento(
            this.cursosSource[this.curso][this.campus][this.turno]
              .PrcInstrumento
          );
        }
      }
    }
  }

  searchArrayProcesso(cursos) {

    if (this.paramtipoProcesso != null && this.processos) {

      let buscaTexto: boolean = false; //Chamado 524575 - Rafael dos Santos - 23/02/2023
      let achouOpcao: boolean = false; //Chamado 524575 - Rafael dos Santos - 23/02/2023

      this.processos.forEach((processo) => {

        // 584948 - Carlos Machado - 22/02/2023
        if (!achouOpcao && this.compareSimilarity(processo.id, this.paramtipoProcesso, buscaTexto)) {
        // if (this.compareSimilarity(processo.id, this.paramtipoProcesso, buscaTexto)) { //Chamado 524575 - Rafael dos Santos - 22/02/2023
          
          achouOpcao = true; //Chamado 524575 - Rafael dos Santos - 23/02/2023

          this.nomeProcessoSelecionado = processo.text;

          this.paramtipoProcesso = null;

          this.cursosSource = cursos;

          this.cursos = this.criaArrayChave(cursos);

          this.atualizaCurso(processo.id);

          return;
        }
      });

      buscaTexto = true //Chamado 524575 - Rafael dos Santos - 23/02/2023

      //Início Chamado - 524575 - Rafael dos Santos - 23/02/2023
      if (buscaTexto && !achouOpcao){

        this.processos.forEach((processo) => {
          if (this.compareSimilarity(processo.text, this.paramtipoProcesso, buscaTexto)) {
            this.nomeProcessoSelecionado = processo.text;

            this.paramtipoProcesso = null;

            this.cursosSource = cursos;

            this.cursos = this.criaArrayChave(cursos);

            this.atualizaCurso(processo.id);

            return;
          }
        });
      }
      //Fim Chamado - 524575 - Rafael dos Santos - 23/02/2023

      return;
    }

    this.cursosSource = cursos;

    this.cursos = this.criaArrayChave(cursos);

    this.searchArrayCurso(cursos);
  }

  searchArrayCurso(cursos) {
    if (cursos) {
      this.paramtipoProcesso = null;

      // busca com igual
      for (const elementCurso of Object.keys(cursos)) {
        if (this.hasElementoIgual(elementCurso, this.paramCurso)) {
          this.curso = elementCurso;
          this.searchArrayCampus(cursos[elementCurso]);
          return;
        }
      }

      // busca com similaridade
      for (const elementCurso of Object.keys(cursos)) {
        if (this.hasElemento(elementCurso, this.paramCurso)) {
          this.curso = elementCurso;
          this.searchArrayCampus(cursos[elementCurso]);
          return;
        }
      }
    }
  }

  searchArrayCampus(campusElementos) {
    if (campusElementos) {
      for (const elementCampus of Object.keys(campusElementos)) {
        if (this.hasElemento(elementCampus, this.paramCampus)) {
          this.campus = elementCampus;
          this.searchArrayTurno(campusElementos[elementCampus]);
        }
        if (Object.keys(campusElementos).length === 1) {
          this.campus = elementCampus;
          this.searchArrayTurno(campusElementos[elementCampus]);
        }
      }
    }
  }

  searchArrayTurno(cursosElementos) {
    if (cursosElementos) {
      for (const elementTurno of Object.keys(cursosElementos)) {
        if (this.hasElemento(elementTurno, this.paramTurno)) {
          this.turno = elementTurno;
          this.grau = cursosElementos[elementTurno].PrcOfeModNom;
        }

        if (Object.keys(cursosElementos).length === 1) {
          this.turno = elementTurno;
          this.grau = cursosElementos[elementTurno].PrcOfeModNom;

          if (cursosElementos[elementTurno].bolsa == "S") {
            this.bolsa = true;
            this.aceiteBolsa = true;
          }

          if (cursosElementos[elementTurno].PrcOfeObs != "") {
            this.PrcOfeObs = cursosElementos[elementTurno].PrcOfeObs;
          }
        }
      }
    }
  }

  hasElemento(elemento, busca) {
    const elementoTratado = this.unidecode(elemento.toLowerCase());
    const similarity = this.stringSimilarity.compareTwoStrings(
      elementoTratado,
      busca
    );
    if (similarity >= 0.8) {
      return true;
    }

    if (elementoTratado.search(busca) >= 0) {
      return true;
    }

    return false;
  }

  compareSimilarity(processo: string, parametro, buscaTexto: boolean) { //Chamado 524575 - Rafael dos Santos - 22/02/2023

    if (parametro == null) {
      return 0;
    }
    processo = this.unidecode(processo.toLowerCase());

    //Início - Chamado 524575 - Rafael dos Santos - 22/02/2023
    //O bloco de similaridade só é executado caso não seja localizado nenhum código na URL do seletivo
    if (buscaTexto) {
      const similarity = this.stringSimilarity.compareTwoStrings(
        processo,
        parametro
      );
      return similarity >= 0.8;
    //O bloco abaixo busca o código do seletivo
    }else{
      let match = parametro.match(/(\d+-\d+)(?=-\b[A-Z]{1,2}\b-\d{4}-\d{1}-InscricaoMatricula$)/);
      let matchAnoSem = parametro.match(/(?<=[a-zA-Z]{1,2}-)(\d{4}-\d)(?=-InscricaoMatricula$)/);
      let parametroExtraido = '';
      let parametroExtraidoAnoSem = '';
      let isExiste = false;

      if (match && matchAnoSem){
        parametroExtraido = match[1];
        parametroExtraidoAnoSem = matchAnoSem[1];

        // 584948 - Carlos Machado - 22/02/2023
        isExiste = processo.includes(`${parametroExtraido}-${parametroExtraidoAnoSem}`);
        // isExiste = processo.includes(parametroExtraido) && processo.includes(parametroExtraidoAnoSem);
      }else{
        isExiste = false;
      }

      return isExiste;
    }
    //Fim - Chamado 524575 - Rafael dos Santos - 22/02/2023
  }

  hasElementoIgual(elemento, busca) {
    const elementoTratado = this.unidecode(elemento.toLowerCase());
    if (elementoTratado == busca) {
      return true;
    }

    return false;
  }

  criaArrayChave(array) {
    if (array) {
      const temp = [];
      let i = 0;

      for (const element of Object.keys(array)) {
        temp[i] = element;
        i++;
      }

      return temp.sort();
    }
  }

  criaArrayInstrumento(object) {
    const temp = [];
    for (const key in object) {
      if (object.hasOwnProperty(key)) {
        temp[object[key]["PrcInsCod"]] = [];
        temp[object[key]["PrcInsCod"]]["id"] = object[key]["PrcInsCod"];
        temp[object[key]["PrcInsCod"]]["text"] = object[key]["PrcInsNom"];
      }
    }
    return temp;
  }

  clearVariables() {
    this.bolsa = false;
    this.aceiteBolsa = false;
    this.curso = "";
    this.grau = "";
    this.PrcOfeObs = "";
    this.instrumento = "";
    this.instrumentos = [];
    this.campi = [];
    this.campus = "";
    this.turno = "";
  }

  atualizaCurso(id) {
    if (id) {
      this.clearVariables();
      let idsplit = id.replace(/InscricaoMatricula$/,'') //Remove "InscricaoMatricula" do final da URL, para que o gx consiga pegar os códigos de PrcTipCod e PrcOcoSeq
      const processo = idsplit.split("-") //id.split("-");
      let PrcTipPrc = sessionStorage.getItem("PrcTipPrc");
      let PrcLetAnoUrl = sessionStorage.getItem("PrcLetAnoUrl");
      let PrcLetSemUrl = sessionStorage.getItem("PrcLetSemUrl");

      if ((PrcTipPrc == "M" || PrcTipPrc == "D" || PrcTipPrc == "MD") &&
      processo.length >= 1 &&
      (processo[2] != this.ProcessoService.getPrcLetAno() ||
      processo[3] != this.ProcessoService.getPrcLetSem() ||
      processo[1] != this.ProcessoService.getOcorrencia() ||
      processo[0] != this.ProcessoService.getTipoProcesso)){
        this.ProcessoService.setPrcLetAno(processo[2]);
        this.ProcessoService.setPrcLetSem(processo[3]);
        this.ProcessoService.setOcorrencia(processo[1]);
        this.ProcessoService.setTipoProcesso(processo[0]);
        this.BarraProgressoService.atualizaNomeProcesso(
          this.ProcessoService.getNomeProcesso()
        );

        this.loadCursosProcessoSeletivo(
          this.cursosService.getCursoProcessoSeletivo(
            this.ProcessoService.getProcessoSeletivo()
          )
        );
      }

      if (
        processo.length > 1 &&
        (processo[1] != this.ProcessoService.getOcorrencia() ||
          processo[0] != this.ProcessoService.getTipoProcesso())
      ) {
        this.ProcessoService.setTipoProcesso(processo[0]);
        this.ProcessoService.setOcorrencia(processo[1]);
        this.BarraProgressoService.atualizaNomeProcesso(
          this.ProcessoService.getNomeProcesso()
        );

        this.loadCursosProcessoSeletivo(
          this.cursosService.getCursoProcessoSeletivo(
            this.ProcessoService.getProcessoSeletivo()
          )
        );
      }
    }
  }

  atualizaCampus(selected) {
    this.clearVariables();
    this.curso = selected;
    this.campi = this.criaArrayChave(this.cursosSource[selected]);

    if (this.campi.length == 1) {
      this.campus = this.campi[0];
      this.atualizaTurno(this.campus);
    }
  }

  removeClaseError() {
    this.curso_classe = "";
    this.campus_classe = "";
    this.turno_classe = "";
  }

  closeOtherSelects(element) {
    if (element) {
      const elementsToclose = this.selectElements.filter(function (el: any) {
        return el != element && el.optionsOpened == true;
      });
      elementsToclose.forEach(function (e: SelectComponent) {
        e.clickedOutside();
      });
    }
  }

  atualizaTurno(selected) {
    this.bolsa = false;
    this.PrcOfeObs = "";
    this.campus = selected;
    this.turnos = this.criaArrayChave(this.cursosSource[this.curso][selected]);
    if (this.turnos.length > 1) {
      this.turno = "";
    } else {
      this.turno = this.turnos[0];
      this.atualizaGrau(this.turno);
    }
  }

  atualizaGrau(selected) {
    this.turno = selected;
    this.PrcOfeObs = "";
    this.grau =
      this.cursosSource[this.curso][this.campus][this.turno].PrcOfeModNom;

    if (this.cursosSource[this.curso][this.campus][this.turno].PrcInstrumento) {
      this.instrumentos = this.criaArrayInstrumento(
        this.cursosSource[this.curso][this.campus][this.turno].PrcInstrumento
      );
    }

    this.bolsa = false;
    this.aceiteBolsa = false;

    if (this.cursosSource[this.curso][this.campus][this.turno].bolsa == "S") {
      this.bolsa = true;
      this.aceiteBolsa = true;
    }

    if (
      this.cursosSource[this.curso][this.campus][this.turno].PrcOfeObs != ""
    ) {
      this.PrcOfeObs =
        this.cursosSource[this.curso][this.campus][this.turno].PrcOfeObs;
    }
  }

  atualizaInstrumento(selected) {
    this.instrumento = selected.text;
  }

  showAlertAceiteEdital() {
    Swal({
      title: "Atenção",
      text: "Por favor, clique no aceite do edital",
      type: "warning",
    });
  }

  // showAlertAceiteBolsa(event) {
  //     if (event && this.aceiteBolsa) {
  //         let html = '';
  //
  //         const tituloBolsa =
  //             'Estou ciente e de acordo com as disposições, critérios e obrigações da bolsa';
  //
  //         if (this.processo.SDTPrcReqBolsa.PtcAceite) {
  //             html += this.processo.SDTPrcReqBolsa.PtcAceite;
  //         }
  //
  //         if (this.processo.SDTPrcReqBolsa.PtcRegras) {
  //             html += this.processo.SDTPrcReqBolsa.PtcRegras;
  //         }
  //
  //         if (this.processo.SDTPrcReqBolsa.RegrasBolsa) {
  //             this.processo.SDTPrcReqBolsa.RegrasBolsa.forEach(bolsa => {
  //                 if (bolsa && bolsa.PtcForDes) {
  //                     html += bolsa.PtcForDes;
  //                 }
  //             });
  //         }
  //
  //         Swal({
  //             title: tituloBolsa,
  //             html: html,
  //             width: 1000,
  //             type: 'info',
  //             showCancelButton: true,
  //             confirmButtonText: 'Li, estou ciente',
  //             cancelButtonText: 'Cancelar'
  //         }).then(result => (this.aceiteBolsa = result.value));
  //     }
  // }

  abrirEdital() {
    this.cursosService
      .carregaLinkEdital()
      .subscribe(({ SDTProcEditalSeletivoLinkEdital: urlEdital }) =>
        window.open(urlEdital)
      );
  }

  proximo() {
    if (
      !this.aceiteEdital ||
      (this.aceiteEdital && !this.aceiteBolsa && this.bolsa)
    ) {
      this.showAlertAceiteEdital();
      return false;
    }

    this.removeClaseError();

    this.formulario = new FormGroup({
      curso: new FormControl(this.curso, Validators.required),
      campus: new FormControl(this.campus, Validators.required),
      turno: new FormControl(this.turno, Validators.required),
    });

    if (this.instrumentos.length > 1) {
      this.formulario.addControl(
        "instrumento",
        new FormControl(this.instrumento, [Validators.required])
      );
    }

    if (this.formulario.status === "INVALID") {
      if (!this.formulario.controls.curso.valid) {
        this.curso_placeholder = "Curso é obrigatório";
        this.curso_classe = "classWarning";
      }

      if (!this.formulario.controls.campus.valid) {
        this.campus_placeholder = "Campus é obrigatório";
        this.campus_classe = "classWarning";
      }

      if (!this.formulario.controls.turno.valid) {
        this.turno_placeholder = "Turno é obrigatório";
        this.turno_classe = "classWarning";
      }

      if (
        this.instrumentos.length > 1 &&
        !this.formulario.controls.instrumento.valid
      ) {
        this.instrumento_placeholder = "Instrumento é obrigatório";
        this.instrumento_classe = "classWarning";
      }
    } else {
      this.SessionService.setValor(
        "cursoSelecionado",
        JSON.stringify(this.cursosSource[this.curso][this.campus][this.turno])
      );
      this.SessionService.setValor("campus", this.campus);
      this.SessionService.setValor("curso", this.curso);
      this.SessionService.setValor("turno", this.turno);
      this.matriculaOnlineRedirecionamento =
        this.ProcessoService.getMatriculaRedirecionamento();

      this.SessionService.setValor(
        "matricula_redirecionar",
        String(this.matriculaOnlineRedirecionamento)
      );

      let candidato = this.CandidatoService.getCandidato();
      if (!candidato) {
        candidato = new Candidato();
      }

      if (this.instrumento) {
        let instrumento_obj;
        this.instrumentos.forEach((element) => {
          if (this.instrumento == element.text) {
            instrumento_obj = element.id;
          }
        });
        this.SessionService.setValor("instrumento", this.instrumento);

        candidato.instrumento = instrumento_obj;
      }

      candidato.bolsa = this.aceiteBolsa;
      this.CandidatoService.setCandidato(candidato);

      const cursoSel = JSON.parse(
        this.SessionService.getValor("cursoSelecionado")
      );

      // Verifica se o candidato é CALOURO
      this.MatriculaService.verificaMatriculaCalouro().subscribe((respostaCalouro) => {

        if (respostaCalouro.possuiMatriculaCalouro) {
          // Se for Calouro, verifica se possui regras para prosseguir com o processo seletivo
          this.MatriculaService.verificaRegrasCalouro().subscribe((respostaRegrasCalouro) => {

            if (respostaRegrasCalouro.isProsseguir == true) {
              Swal({
                width: 600,
                title: "Atenção",
                html: respostaRegrasCalouro.Mensagem,
                type: "info",
                confirmButtonText: "Prosseguir",
                confirmButtonColor: "#3085d6",
              }).then((respostaSwallCalouro) => {

                  if (respostaSwallCalouro.value) {
                    this.router.navigateByUrl("/endereco");
                  }
                });
              } else {
                Swal({
                  width: 600,
                  title: "Atenção",
                  html: respostaRegrasCalouro.Mensagem,
                  type: "warning",
                  confirmButtonText: "OK",
                  confirmButtonColor: "#3085d6",
                });
              }
            }
          );
        } else {
          this.ProcessoService.validaRegrasBolsa({
            PrcOfeSeq: cursoSel.PrcOfeSeq,
            Vinculo: true,
            CidadeMoradia: false,
          }).subscribe((response) => {
            if (response.PtcTipMsgDes) {
              Swal({
                width: 600,
                title: "Atenção",
                html: response.PtcTipMsgDes,
                type: "warning",
              });

              return;
            }

            // Se não for Calouro, segue o fluxo normal verificando se está na lista de espera.
            this.ProcessoService.validaListaEspera().subscribe((res) => {
              this.SessionService.setValor("matriculado", res.Matriculado);
              let PrcTipPrc = this.SessionService.getValor("PrcTipPrc");

              this.SessionService.setValor("matriculado", res.Matriculado);
              if (res.Mensagem) {
                if (res.Aceite) {
                  Swal({
                    width: 600,
                    title: "Atenção",
                    html: res.Mensagem,
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: "Outra forma",
                    confirmButtonColor: "#aaaaaa",
                    cancelButtonText: "Permanecer",
                    cancelButtonColor: "#3085d6",
                    focusCancel: true,
                  }).then(({ value }) => {
                    if (value) {
                      this.ProcessoService.excluirListaEspera().subscribe(
                        (excluiu) => {
                          this.router.navigateByUrl("/endereco");
                        }
                      );
                    }
                  });

                  return;
                }
                const redirecionaParaMatricula: boolean = Boolean(
                  this.matriculaOnlineRedirecionamento && !res.Matriculado
                );

                // 588275 - Carlos Machado - 17/06/2025: Adicionado fluxo do stricto que tinha se perdido na produção da 926
                if ((PrcTipPrc == "M" || PrcTipPrc == "D" || PrcTipPrc == "MD") && res.Ciente == true){

                  Swal({
                    width: 500,
                    title: "Atenção",
                    html: res.Mensagem,
                    type: "warning",
                    confirmButtonText: redirecionaParaMatricula //check matriculado
                      ? "MATRÍCULA"
                      : "CIENTE",
                  }).then(() => {
                    this.router.navigateByUrl("/endereco");
                  });

                }else{

                  Swal({
                    width: 500,
                    title: "Atenção",
                    html: res.Mensagem,
                    type: "warning",
                    confirmButtonText: redirecionaParaMatricula //check matriculado
                      ? "MATRÍCULA"
                      : "OK",
                  }).then(() => {
                    if (redirecionaParaMatricula) {
                      this.ProcessoService.enviaLogMatricula().subscribe(
                        (result) => {
                          this.RedirecionamentoMatriculaService.redirecionar();
                          return;
                        },
                        (err) => {
                          this.SessionService.clear();
                          return err;
                        }
                      );
                    }
                  });
                }

                return;
              }

              this.router.navigateByUrl("/endereco");
            });
          });
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/curso/curso.component.ts